import Api from './coreapi';
export default {
    orderHeader: {
        VendorId: '',
        VendorName: '',
        Discount: 0,
        Deposit: 0,
        GrandTotal: 0,
        TaxVat: 0,
        PaidAmount: 0,
        Contact: '',
        Balance: 0,
        BranchId: '',
        DocSource: 'Manual',
        DocSourceNo: '',
        RefNum: '',
        Type: 1,
        BillNo: ''
    },
    orderLine:  {
        ItemId: '',
        ItemName: '',
        Uoms: [],
        UomId: '',
        UomName: '',
        Quantity: 1,
        Price: 0,
        Discount: 0,
        TaxLine: 0,
        SubTotal: 0,
        ExchangeRate: 0,
        BranchId: '',
        AccountId: '',
        AccountName: null
    },
    select(filter){
        return new Promise((resolve) => {
            Api.request().post('po/invoices', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    selectPayment(filter){
        return new Promise((resolve) => {
            Api.request().post('po/receipts', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    selectByVendor(filter){
        return new Promise((resolve) => {
            Api.request().post('purchase/filter-order-vendor', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data.Json);
                }
            });
        });
    },
    findOrderById(filter){
        return new Promise((resolve) => {
            Api.request().post('purchase/order/find', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data.Json);
                }
            });
        });
    },
    findPaymentById(filter){
        return new Promise((resolve) => {
            Api.request().post('po/receipt/find', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data.Json);
                }
            });
        });
    },
    findPaymentPreview(filter){
        return new Promise((resolve) => {
            Api.request().post('purchase/receipt/preview', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data.Json);
                }
            });
        });
    },
    savePayment(model, isUpdate = false){
        let actionLink = isUpdate?'po/receipt/update':'po/receipt/save';
        return new Promise((resolve) => {
            Api.request().post(actionLink, model).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data.Json);
                }
            });
        });
    },
    saveInvoice(model, isUpdate = false){
        let actionLink = isUpdate?'po/invoice/update':'po/invoice/save';
        return new Promise((resolve) => {
            Api.request().post(actionLink, model).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data.Json);
                }
            });
        });
    },
    approvePayment(filter){
        return new Promise((resolve) => {
            Api.request().post('po/receipt/approval', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    deletePayment(filter){
        return new Promise((resolve) => {
            Api.request().post('po/receipt/cancel', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    }
}